module.exports = __webpack_public_path__ + "img/info-result.24d5552f.svg";